import { useCallback } from 'react';
import { useToggle } from 'react-use';

import { PatientNote, PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { EditIcon, Link, LinkSize } from '@dreryk/react-components';

import { notesTranslationKeys } from '../../translations';
import { NoteFormBean, NoteModalCommon } from '../NoteModalCommon/NoteModalCommon';
import { usePatientNoteQuery } from '../patientNoteHooks';

import { usePatientNoteUpdateCommand } from './EditNoteModal.hooks';

type EditNoteModalProps = Pick<PatientNote, 'id' | 'content' | 'createdBy'> & {
   readonly patientId: PatientSimple['id'];
};

export const EditNoteModal = (props: EditNoteModalProps): JSX.Element => {
   const [modalOpened, toggleModalOpened] = useToggle(false);
   const { refetch: refetchNotes } = usePatientNoteQuery(props.patientId);

   const onSuccess = (): void => {
      toggleModalOpened();
      refetchNotes();
   };

   const { executeAsync: updatePatientNote } = usePatientNoteUpdateCommand(onSuccess);

   const onSubmit = useCallback(
      (data: NoteFormBean) => {
         updatePatientNote({ ...data, id: props.id });
      },
      [updatePatientNote, props.id]
   );

   return (
      <>
         <Link size={LinkSize.SMALL} onClick={toggleModalOpened} icon={<EditIcon />} testId={'editNote'} />

         {modalOpened ? (
            <NoteModalCommon
               content={props.content}
               toggleModalOpened={toggleModalOpened}
               onSubmit={onSubmit}
               confirmationButtonLabel={notesTranslationKeys.modal.saveNote}
               title={notesTranslationKeys.modal.editNoteTitle}
               exitConfirmationMessage={notesTranslationKeys.modal.cancelEdit}
               testId={'editNoteModal'}
               author={props.createdBy}
            />
         ) : null}
      </>
   );
};
